<template>
  <div class="digital-transformation-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/consulting">咨询</router-link>
      <span class="separator">/</span>
      <span class="current">数字化转型</span>
    </nav>

    <!-- 1️⃣ Banner区 -->
    <section id="banner" class="section">
      <div class="banner">
        <div class="grid-2">
          <div>
            <h1>数字化转型咨询</h1>
            <div class="banner-sub">数字化转型，建立企业可持续增长数字化运营体系，驱动业务增长。古杉数据数字化转型咨询服务，本质通过深度融合战略、运营与技术，帮助企业从根本上重塑核心竞争力，在数字时代建立可持续的领先优势。</div>
            <div class="banner-tags">
              <h2 class="banner-tag">数字化转型</h2>
              <h2 class="banner-tag">IT规划</h2>
              <h2 class="banner-tag">数据规划</h2>
              <h2 class="banner-tag">战略级顶层设计</h2>
              <h2 class="banner-tag">数据驱动运营</h2>
              <h2 class="banner-tag">业务价值落地</h2>
            </div>
            <div class="banner-buttons">
              <h2 class="banner-tag">价值凸显为试点</h2>
              <h2 class="banner-tag">头部企业最佳实践</h2>
              <h2 class="banner-tag">成熟方法论及落地思路</h2>
            </div>
          </div>
          <div class="banner-visual">
            <div class="network-grid">
              <i class="fas fa-circle-nodes"></i>
              <i class="fas fa-chart-line" style="font-size: 60px; color: rgba(255,255,255,0.3);"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 新增固定导航导航 -->
    <section class="nav-fixed">
      <div class="nav-container">
        <div class="nav-menu-inner">
          <a href="#banner" class="nav-item-inner" :class="{ active: currentSection === 'banner' }" @click.prevent="scrollTo('banner')">首页</a>
          <a href="#services" class="nav-item-inner" :class="{ active: currentSection === 'services' }" @click.prevent="scrollTo('services')">咨询服务</a>
          <a href="#features" class="nav-item-inner" :class="{ active: currentSection === 'features' }" @click.prevent="scrollTo('features')">显著特点</a>
          <a href="#advantages" class="nav-item-inner" :class="{ active: currentSection === 'advantages' }" @click.prevent="scrollTo('advantages')">服务优势</a>
          <a href="#framework" class="nav-item-inner" :class="{ active: currentSection === 'framework' }" @click.prevent="scrollTo('framework')">咨询框架</a>
          <a href="#clients" class="nav-item-inner" :class="{ active: currentSection === 'clients' }" @click.prevent="scrollTo('clients')">成功客户</a>
          <a href="#reports" class="nav-item-inner" :class="{ active: currentSection === 'reports' }" @click.prevent="scrollTo('reports')">专题报告</a>
          <a href="#contact" class="nav-item-inner" :class="{ active: currentSection === 'contact' }" @click.prevent="scrollTo('contact')">预约咨询</a>
        </div>
      </div>
    </section>

    <!-- 2️⃣ 咨询服务内容模块（四卡片结构） -->
    <section id="services" class="section">
      <div class="container">
        <h2>咨询服务内容</h2>
        <div class="grid-4">
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-chart-pie"></i></div>
            <h3>业务战略与增长</h3>
            <p>明确转型方向，寻找新的增长点，从集团战略出发构建数字化蓝图。代表：产业金融、科技金融4C解决方案。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-users"></i></div>
            <h3>客户体验与营销</h3>
            <p>以客户为中心，提升全渠道交互体验，围绕业务价值重构流程与系统，提升用户满意度。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-sitemap"></i></div>
            <h3>运营模式与敏捷组织</h3>
            <p>建立"AI生产流程"、打造"前线部署"团队、"产品型组织"转型。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-cloud"></i></div>
            <h3>技术赋能与数据平台</h3>
            <p>夯实云、数据、AI技术基础，打通数据孤岛，实现统一口径与智能化决策。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 2️⃣ 咨询服务显著特点（四卡片结构） -->
    <section id="features" class="section">
      <div class="container">
        <h2>咨询服务的显著特点</h2>
        <div class="grid-4">
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-bullseye"></i></div>
            <h3>业务导向</h3>
            <p>强调"业务导向"，而非"技术驱动"，从市场和客户出发发现价值最大的机会。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-handshake"></i></div>
            <h3>端到端陪跑</h3>
            <p>提供"端到端"的长期陪跑服务，至少三年长期转型支持，确保战略真正落地。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-chart-line"></i></div>
            <h3>价值创造为核心</h3>
            <p>恪守"价值创造"为核心目标，聚焦可量化的业务成果，提升收入、降低成本。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-flask"></i></div>
            <h3>客户零号实验</h3>
            <p>自身即是"客户零号"，以身试"数"，内部验证AI解决方案，积累实战经验。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 3️⃣ 服务优势模块 -->
    <section id="advantages" class="section">
      <div class="container">
        <h2>服务优势</h2>
        <div class="grid-2">
          <div>
            <p style="font-size: 18px; margin-bottom: 20px;">我们拥有行业深耕能力、体系化方法论、技术+咨询一体化，成果可量化。</p>
            <ul style="list-style: none;">
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>行业深耕能力：覆盖能源、金融、制造、政府</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>体系化方法论：五阶段框架 + 30+工具包</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>技术+咨询一体化：从战略到平台落地</li>
              <li><i class="fas fa-check-circle" style="color: var(--primary-blue); margin-bottom: 20px; margin-right: 12px;"></i>成果可量化：效率提升30%+，成本下降20%</li>
            </ul>
          </div>
          <div class="advantage-stats">
            <div class="stat-item">
              <div class="stat-number" ref="stat1">0+</div>
              <div>服务客户</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" ref="stat2">0%</div>
              <div>客户留存率</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" ref="stat3">0%</div>
              <div>平均效率提升</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" ref="stat4">0+</div>
              <div>行业奖项</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 4️⃣ 咨询框架（方法论模型） -->
    <section id="framework" class="section">
      <div class="container">
        <h2>古杉数字化转型框架</h2>
        <div class="timeline-horizontal">
          <div class="timeline-step" @click="activeStep = 1">
            <div class="timeline-marker">1</div>
            <div class="timeline-title">现状评估</div>
            <div class="timeline-desc">Assessment</div>
          </div>
          <div class="timeline-step" @click="activeStep = 2">
            <div class="timeline-marker">2</div>
            <div class="timeline-title">战略设计</div>
            <div class="timeline-desc">Strategy</div>
          </div>
          <div class="timeline-step" @click="activeStep = 3">
            <div class="timeline-marker">3</div>
            <div class="timeline-title">蓝图规划</div>
            <div class="timeline-desc">Blueprint</div>
          </div>
          <div class="timeline-step" @click="activeStep = 4">
            <div class="timeline-marker">4</div>
            <div class="timeline-title">实施落地</div>
            <div class="timeline-desc">Implementation</div>
          </div>
          <div class="timeline-step" @click="activeStep = 5">
            <div class="timeline-marker">5</div>
            <div class="timeline-title">持续优化</div>
            <div class="timeline-desc">Optimization</div>
          </div>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 1 }">
          <h3>现状评估阶段</h3>
          <p>目标：诊断企业数字化成熟度，识别痛点与机会</p>
          <p>关键动作：业务访谈、数据盘点、流程分析、对标研究</p>
          <p>交付物：数字化成熟度报告、机会清单、初步建议</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 2 }">
          <h3>战略设计阶段</h3>
          <p>目标：制定数字化转型愿景、战略路径与蓝图</p>
          <p>关键动作：战略工作坊、业务场景设计、价值测算</p>
          <p>交付物：数字化转型战略规划书、三年路线图</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 3 }">
          <h3>蓝图规划阶段</h3>
          <p>目标：设计业务架构、数据架构、技术架构</p>
          <p>关键动作：架构设计、平台选型、组织设计</p>
          <p>交付物：数字化蓝图方案、实施计划</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 4 }">
          <h3>实施落地阶段</h3>
          <p>目标：敏捷交付试点项目，建立规模化能力</p>
          <p>关键动作：试点项目、能力中心建设、变革管理</p>
          <p>交付物：试点成果、规模化推广方案</p>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 5 }">
          <h3>持续优化阶段</h3>
          <p>目标：建立持续改进机制，保障长效运营</p>
          <p>关键动作：运营监控、迭代优化、能力固化</p>
          <p>交付物：运营指标体系、持续优化机制</p>
        </div>
        <!--
        <div style="text-align: center;">
          <a href="#" class="download-pdf" @click.prevent="downloadPdf"><i class="fas fa-download"></i> 下载方法论PDF</a>
        </div>
          -->
      </div>
    </section>

    <!-- 5️⃣ 成功客户列表模块 -->
    <section id="clients" class="section">
      <div class="container">
        <h2>成功客户</h2>
        <div class="industry-filter">
          <span class="filter-btn" :class="{ active: activeFilter === 'all' }" @click="activeFilter = 'all'">全部</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'energy' }" @click="activeFilter = 'energy'">能源电力</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'finance' }" @click="activeFilter = 'finance'">金融保险</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'manufacturing' }" @click="activeFilter = 'manufacturing'">制造业</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'government' }" @click="activeFilter = 'government'">政府单位</span>
        </div>
        <div class="logo-wall">
          <div v-for="client in filteredClients" :key="client.name" class="logo-item">
            {{ client.name }}
            <div class="logo-tooltip">{{ client.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 6️⃣ 专业专题报告模块 -->
    <section id="reports" class="section">
      <div class="container">
        <h2>数字化转型专题报告</h2>
        <div class="report-grid">
          <a class="report-card" href="https://mp.weixin.qq.com/s/KUY7dO6d9_NaYGDME0Ni4w" target="_blank" rel="noopener">
            <span style="color: #1F3F8F; font-weight: 600;">McKinsey</span>
            <h3 style="margin: 12px 0;">企业数字化转型内涵，路径，评估及案例</h3>
            <p style="color: #5f6a7d;">麦肯锡视角解读企业数字化转型的内涵、实施路径、评估体系及经典案例。</p>
            <span class="read-link">阅读专题 →</span>
          </a>
          <a class="report-card" href="https://mp.weixin.qq.com/s/uIcsrUq0NSfzSu94nQUzsQ" target="_blank" rel="noopener">
            <span style="color: #1F3F8F; font-weight: 600;">行业实践</span>
            <h3 style="margin: 12px 0;">锂电池数字化转型与数据管理规划</h3>
            <p style="color: #5f6a7d;">聚焦锂电池行业，探索数字化转型与数据管理规划的落地路径。</p>
            <span class="read-link">阅读专题 →</span>
          </a>
          <a class="report-card" href="https://mp.weixin.qq.com/s/cbeBvzHlcFQxMwFiRg4uQw" target="_blank" rel="noopener">
            <span style="color: #1F3F8F; font-weight: 600;">艾森哲 · 2026</span>
            <h3 style="margin: 12px 0;">十五五数字化转型规划</h3>
            <p style="color: #5f6a7d;">艾森哲2026年最新报告，解读"十五五"期间企业数字化转型的战略规划。</p>
            <span class="read-link">阅读专题 →</span>
          </a>
          <a class="report-card" href="https://mp.weixin.qq.com/s/6wtxU2-Bzo_JCAB9kNNO5g" target="_blank" rel="noopener">
            <span style="color: #1F3F8F; font-weight: 600;">IBM</span>
            <h3 style="margin: 12px 0;">IBM集团企业数字化转型解决方案：破局之路与实战攻略</h3>
            <p style="color: #5f6a7d;">IBM视角的企业数字化转型解决方案，涵盖破局思路与实战攻略。</p>
            <span class="read-link">阅读专题 →</span>
          </a>
          <a class="report-card" href="https://mp.weixin.qq.com/s/hEcPxR4F7gIIW2B_jxErxQ" target="_blank" rel="noopener">
            <span style="color: #1F3F8F; font-weight: 600;">行业咨询</span>
            <h3 style="margin: 12px 0;">石油化工行业数字化转型</h3>
            <p style="color: #5f6a7d;">深入分析石油化工行业数字化转型的挑战与机遇。</p>
            <span class="read-link">阅读专题 →</span>
          </a>
          <a class="report-card" href="https://mp.weixin.qq.com/s/Z7TNwr9rjXHk9ahsCNn6Jg" target="_blank" rel="noopener">
            <span style="color: #1F3F8F; font-weight: 600;">规划方法论</span>
            <h3 style="margin: 12px 0;">数字化转型及IT规划</h3>
            <p style="color: #5f6a7d;">系统性梳理数字化转型及IT规划的方法论与实施框架。</p>
            <span class="read-link">阅读专题 →</span>
          </a>
        </div>
        <div class="load-more">
          <button class="btn-load-more" @click="loadMore">加载更多</button>
        </div>
      </div>
    </section>

    <!-- 7️⃣ 底部转化模块 -->
    <section id="contact" class="section cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建可信、统一的数字化转型战略与运营体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>咨询方向</label>
            <select>
              <option value="">-- 请选择咨询方向 --</option>
              <option>战略规划 / 顶层设计</option>
              <option>数字化运营体系建设</option>
              <option>数据驱动增长</option>
              <option>AI 大模型应用落地</option>
              <option>数字化人才培养</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「数字化转型」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'ConsultDetailDigitalTransformation',
  data() {
    return {
      currentSection: 'banner',
      activeStep: 1,
      activeFilter: 'all',
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      clients: [
        { name: '国家能源集团', industry: 'energy', desc: '数据治理体系建设' },
        { name: '中国工商银行', industry: 'finance', desc: '产业金融数字化转型' },
        { name: '中国中车', industry: 'manufacturing', desc: '智能制造+数据平台' },
        { name: '南方电网', industry: 'energy', desc: '数据资产运营' },
        { name: '中国人保', industry: 'finance', desc: '保险科技+AI风控' },
        { name: '北京市经信局', industry: 'government', desc: '数据要素治理咨询' }
      ]
    }
  },
  computed: {
    filteredClients() {
      if (this.activeFilter === 'all') return this.clients
      return this.clients.filter(c => c.industry === this.activeFilter)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.animateNumbers()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      const sections = this.$el.querySelectorAll('.section')
      const scrollPos = window.pageYOffset + 100
      sections.forEach(section => {
        const top = section.offsetTop - 70
        const bottom = top + section.offsetHeight
        if (scrollPos >= top && scrollPos < bottom && section.id) {
          this.currentSection = section.id
        }
      })
    },
    animateNumber(element, target, suffix) {
      let current = 0
      const increment = target / 80
      const timer = setInterval(() => {
        current += increment
        if (current >= target) {
          element.innerText = target + suffix
          clearInterval(timer)
        } else {
          element.innerText = Math.floor(current) + suffix
        }
      }, 16)
    },
    animateNumbers() {
      this.$nextTick(() => {
        const stats = [
          { ref: 'stat1', target: 200, suffix: '+' },
          { ref: 'stat2', target: 85, suffix: '%' },
          { ref: 'stat3', target: 30, suffix: '%' },
          { ref: 'stat4', target: 15, suffix: '+' }
        ]
        stats.forEach(stat => {
          if (this.$refs[stat.ref]) {
            this.animateNumber(this.$refs[stat.ref], stat.target, stat.suffix)
          }
        })
      })
    },
    downloadPdf() {
      console.log('PDF下载点击埋点')
      alert('PDF下载功能已触发，可在此处集成真实下载逻辑。')
    },
    submitForm() {
      alert('表单已提交')
      this.showModal = false
    },
    showQrCode() {
      this.showQrModal = true
    },
    loadMore() {
      this.$router.push('/consulting/digital-transformation/articles')
    }
  }
}
</script>

<style scoped>
/* 面包屑 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}
.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb-nav .current {
  color: #2B2F3A;
}

.digital-transformation-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --card-shadow: 0 12px 28px rgba(0,10,30,0.04), 0 4px 16px rgba(31,63,143,0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 固定导航 */
.nav-fixed {
  position: sticky;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.02);
  z-index: 999;
  border-bottom: 1px solid rgba(31,63,143,0.1);
  height: var(--nav-height);
  backdrop-filter: blur(8px);
  background: rgba(255,255,255,0.9);
}
.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-menu-inner {
  display: flex;
  gap: 12px;
  background-color: #f5f7fa;
  padding: 4px;
  border-radius: 40px;
}
.nav-item-inner {
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #2B2F3A;
  border-radius: 32px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  background-color: transparent;
  border: none;
  white-space: nowrap;
}
.nav-item-inner:hover {
  background-color: #EAF0FB;
  color: #1F3F8F;
}
.nav-item-inner.active {
  background-color: #1F3F8F;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(31,63,143,0.2);
}


/* 通用样式 */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
  
}

@keyframes sectionFadeIn {
  to { opacity: 1; transform: translateY(0); }
}

h1 {
  font-size: 42px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 24px;
  letter-spacing: -0.02em;
  line-height: 1.2;
}


h2 {
  font-size: 28px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 40px;
  letter-spacing: -0.01em;
  position: relative;
  display: inline-block;
}

h2:after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: var(--primary-blue);
  border-radius: 4px;
}


h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--deep-indigo);
}

/* Banner区 */
.banner {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  border-radius: 32px;
  padding: 60px 48px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.banner::before {
  content: '';
  position: absolute;
  top: -30%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(234,240,251,0.1) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 0;
}
.banner .grid-2 {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}
.banner h1 {
  color: white;
  margin-bottom: 16px;
}
.banner-sub {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
  max-width: 550px;
  margin-bottom: 24px;
}
.banner-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0;
}
.banner-tag {
  background: rgba(255,255,255,0.15);
  color: white;
  padding: 6px 18px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(255,255,255,0.2);
  backdrop-filter: blur(4px);
  transition: all 0.3s;
}
.banner-tag:hover {
  background: rgba(255,255,255,0.25);
  transform: translateY(-2px);
}
.banner-buttons {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}

.btn-outline-light {
  background: #EAF0FB;
  color: black;
  border: 1px solid #0e3170;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  text-decoration: none;
}

.btn-outline-light:hover {
  background: rgba(255,255,255,0.1);
  border-color: #0e3170;
}

.banner-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}
.network-grid {
  width: 100%;
  max-width: 400px;
  height: 280px;
  background: rgba(255,255,255,0.05);
  border-radius: 24px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.network-grid i {
  font-size: 100px;
  color: rgba(255,255,255,0.2);
  position: absolute;
}
.network-grid .fa-circle-nodes {
  font-size: 140px;
  opacity: 0.3;
}

/* 四卡片网格 */
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.service-card {
  background: white;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s ease;
  border: 1px solid rgba(31,63,143,0.05);
  cursor: pointer;
}
.service-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.card-icon {
  width: 56px;
  height: 56px;
  background: var(--light-porcelain);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-blue);
  font-size: 28px;
  margin-bottom: 20px;
}

/* 左右布局 */
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}

.load-more {
  text-align: center;
  margin-top: 40px;
}
.btn-load-more {
  background: transparent;
  color: var(--primary-blue);
  border: 1px solid var(--primary-blue);
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  cursor: pointer;
  font-size: 16px;
}
.btn-load-more:hover {
  background: var(--light-porcelain);
}

/* 优势数字 */
.advantage-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 30px;
}
.stat-item {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: var(--card-shadow);
  text-align: center;
}
.stat-number {
  font-size: 42px;
  font-weight: 700;
  color: var(--primary-blue);
  line-height: 1.2;
}

/* 时间轴五阶段 */
.timeline-horizontal {
  display: flex;
  justify-content: space-between;
  margin: 40px 0;
  position: relative;
}
.timeline-step {
  flex: 1;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.timeline-marker {
  width: 40px;
  height: 40px;
  background: var(--primary-blue);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-weight: 600;
  transition: all 0.3s;
}
.timeline-step:hover .timeline-marker {
  transform: scale(1.1);
  background: var(--deep-indigo);
}
.timeline-title {
  font-weight: 600;
  margin-bottom: 8px;
}
.timeline-desc {
  font-size: 14px;
  color: #5f6a7d;
  max-width: 180px;
  margin: 0 auto;
}
.step-detail {
  background: var(--light-porcelain);
  border-radius: 16px;
  padding: 24px;
  margin-top: 30px;
  display: none;
}
.step-detail.active {
  display: block;
}
.download-pdf {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  padding: 12px 28px;
  border-radius: 40px;
  text-decoration: none;
  margin-top: 20px;
  transition: 0.3s;
}
.download-pdf:hover {
  background: #0e3170;
}

/* Logo墙 + 筛选 */
.industry-filter {
  display: flex;
  gap: 12px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.filter-btn {
  padding: 8px 24px;
  border-radius: 40px;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
}
.filter-btn.active, .filter-btn:hover {
  background: var(--primary-blue);
  color: white;
}
.logo-wall {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  background: var(--bg-light);
  padding: 40px;
  border-radius: 32px;
}
.logo-item {
  background: white;
  padding: 16px 32px;
  border-radius: 60px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0,0,0,0.02);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(31,63,143,0.1);
}
.logo-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(31,63,143,0.15);
}
.logo-tooltip {
  display: none;
  background: var(--deep-indigo);
  color: white;
  padding: 8px 16px;
  border-radius: 40px;
  font-size: 14px;
  margin-top: 8px;
}
.logo-item:hover .logo-tooltip {
  display: block;
}

/* 报告卡片 */
.report-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
.report-card {
  background: white;
  border-radius: 16px;
  padding: 28px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  position: relative;
}

.report-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}


.read-link {
  margin-top: auto;
  padding-top: 16px;
  text-align: right;
  color: #1F3F8F;
  font-size: 14px;
  font-weight: 600;
  transition: color 0.3s;
}



.report-card:hover .read-link {
  color: #0e3170;
}

/* ============ 底部转化模块 ============ */
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}






/* 响应式 */
@media (max-width: 992px) {
  .grid-4 { grid-template-columns: repeat(2, 1fr); }
  .grid-2 { grid-template-columns: 1fr; }
  .banner .grid-2 { grid-template-columns: 1fr; }
  .timeline-horizontal { flex-wrap: wrap; gap: 20px; }
  .report-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 640px) {
  .grid-4 { grid-template-columns: 1fr; }
  .report-grid { grid-template-columns: 1fr; }
  .nav-menu-inner { flex-wrap: wrap; height: auto; }
}
</style>
